import React, { useRef, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Row, Col, Input, Button, ConfigProvider } from 'antd'
import { formatMessageNew } from '@/utils/common'
import { modalSuccess, modalError, destroyModal } from '@/utils/modalUtils'
import { unbindByPiece, getSkuByPiece } from '@/services/qrCode/unbind'
import { readRfid, resetRfid } from '@/services/qrCode/binding'
import '@/pages/AndroidDevice/PhoneLayout.less'
let errorModal = null
let successModal = null
let errorNum = 0
const QrCodeUnbindByPiecePage = () => {
  const history = useHistory()
  const qrCodeInputRef = useRef(null)
  const epcInputRef = useRef(null)
  const macState = useSelector(state => state.commonStore.mac)
  const deviceCode = useSelector(state => state.commonStore.deviceCode)
  const [epcValue, setEpcValue] = useState('')
  const [skuValue, setSkuValue] = useState('')
  const [codeSkuValue, setCodeSkuValue] = useState('')
  const [qrCodeValue, setQrCodeValue] = useState('')
  const [inputReadOnly, setInputReadOnly] = useState(false)
  const queryHeader = {
    isRF: true,
    mac: macState,
    deviceCode,
    operator: deviceCode
  }
  // 页面初始化
  useEffect(() => {
    epcInputRef.current.focus({ cursor: 'all' })
    // 监听全局键盘事件
    window.addEventListener('keydown', onWindowKeyDown)
    window.addEventListener('keyup', onWindowKeyUp)
    return () => {
      // 移除全局键盘事件
      window.removeEventListener('keydown', onWindowKeyDown)
      window.removeEventListener('keyup', onWindowKeyUp)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // 弹出 输入框要失焦点，防止再次触发回车事件
  // useEffect(() => {
  //   qrCodeInputRef.current.blur()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [errorModal, successModal])

  // 全局键盘事件
  const onWindowKeyDown = e => {
    console.log('e.keyCode11', e.key, e.code, e.keyCode)
    if (e.keyCode === 0 && e.code === 'F23') {
      getEpcValueFun()
      return
    }
    if (e.keyCode === 13) {
      // 关闭 错误提示弹窗
      if (errorModal) {
        destroyModal(errorModal)
        errorModal = null
        errorNum = 0
      }
      // 关闭 成功提示弹窗
      if (successModal) {
        destroyModal(successModal)
        successModal = null
        setEpcValue('')
        setQrCodeValue('')
        errorNum = 0
      }
      return
    }
    // if (e.keyCode === 112) {
    //   // F1 => 112
    //   unbindingFun()
    //   return
    // }
    // if (e.keyCode === 113) {
    //   // F2 => 113
    //   clearInfoFun()
    //   return
    // }
  }
  // 全局键盘事件
  const onWindowKeyUp = e => {
    if (e.keyCode === 13) {
      setTimeout(() => {
        epcInputRef.current.focus({ cursor: 'all' })
      }, 500)
    }
  }

  const onInputChange = e => {
    const value = e.target.value.trim()
    console.log('value', value)
    const index = value.indexOf('/n')
    const newValue = index > -1 ? value.substring(0, index) : value
    setQrCodeValue(newValue)
  }

  const onEpcChange = e => {
    setEpcValue(e.target.value)
  }
  const getEpcValueFun = () => {
    setEpcValue('')
    readRfid()
      .then(res => {
        const value = res?.resultData?.rfid
        if (value.split(',').length > 1) {
          if (errorNum !== 0) return
          errorNum = 1
          let str = formatMessageNew('languageObj.qrCode.multipleEpc')
          errorModal = modalError(
            {
              content: str
            },
            () => {
              errorModal = null
              errorNum = 0
            }
          )
          return
        }
        setEpcValue(value === 'null' ? '' : value)
        resetRfid()
      })
      .catch(err => {
        if (errorNum !== 0) return
        errorNum = 1
        let str = formatMessageNew('languageObj.qrCode.readEpcErr')
        errorModal = modalError(
          {
            content: str
          },
          () => {
            errorModal = null
            errorNum = 0
          }
        )
      })
  }
  // 获取sku
  useEffect(() => {
    if (epcValue) {
      getSkuByPieceFun()
    } else {
      setSkuValue('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [epcValue])
  // 获取sku
  useEffect(() => {
    if (!qrCodeValue) {
      setCodeSkuValue('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qrCodeValue])
  const onInputKeyDown = (e, type) => {
    if (e.keyCode === 13) {
      if (type === 'qr') {
        getSkuByPieceFunCode()
      }
    }
  }
  const getSkuByPieceFun = () => {
    let params = {
      epc: epcValue,
      qrCode: ''
    }
    getSkuByPiece(params, queryHeader).then(res => {
      setSkuValue(res.resultData)
    })
  }
  const getSkuByPieceFunCode = () => {
    let params = {
      epc: '',
      qrCode: qrCodeValue
    }
    getSkuByPiece(params, queryHeader).then(res => {
      setCodeSkuValue(res.resultData)
    })
  }
  const onInputFocus = e => {
    setInputReadOnly(true)
    setTimeout(() => {
      setInputReadOnly(false)
    }, 100)
  }
  // 根据箱号获取订单信息

  const unbindingFun = () => {
    console.log(1, epcValue, qrCodeValue)
    qrCodeInputRef.current.focus({ cursor: 'all' })
    if (!macState) {
      errorModal = modalError({
        content: formatMessageNew('languageObj.nsptagLocale.rfMacError')
      })
      return
    }
    if (!epcValue && !qrCodeValue) {
      return
    }
    let params = {
      epc: epcValue,
      qrCode: qrCodeValue
    }
    qrCodeInputRef.current.blur()
    unbindByPiece(params, queryHeader)
      .then(res => {
        if (errorNum === 0) {
          errorNum = 1
          successModal = modalSuccess(
            {
              title: formatMessageNew('languageObj.qrCode.unbindByCartonSuccess'),
              content: (
                <div>
                  {epcValue ? (
                    <div className="fwb displayFlex">
                      <div style={{ width: 80 }} className="pr8 alignR">
                        {formatMessageNew('languageObj.qrCode.rfidEpc')}:
                      </div>
                      <div className="word_break_all" style={{ flex: 1 }}>
                        {epcValue}
                      </div>
                    </div>
                  ) : (
                    <div className="fwb displayFlex">
                      <div style={{ width: 80 }} className="pr8 alignR">
                        {formatMessageNew('languageObj.qrCode.qrCode')}:
                      </div>
                      <div className="word_break_all" style={{ flex: 1 }}>
                        {qrCodeValue}
                      </div>
                    </div>
                  )}
                  {epcValue ? (
                    <div className="fwb displayFlex mt8">
                      <div style={{ width: 80 }} className="pr8 alignR">
                        {formatMessageNew('languageObj.qrCode.sku')}:
                      </div>
                      <div className="word_break_all" style={{ flex: 1 }}>
                        {skuValue}
                      </div>
                    </div>
                  ) : (
                    <div className="fwb displayFlex mt8">
                      <div style={{ width: 80 }} className="pr8 alignR">
                        {formatMessageNew('languageObj.qrCode.sku')}:
                      </div>
                      <div className="word_break_all" style={{ flex: 1 }}>
                        {codeSkuValue}
                      </div>
                    </div>
                  )}
                </div>
              )
            },
            () => {
              setEpcValue('')
              setQrCodeValue('')
              epcInputRef.current.focus({ cursor: 'all' })
              errorNum = 0
            }
          )
        }
      })
      .catch(err => {
        if (errorNum === 0) {
          errorNum = 1
          errorModal = modalError(
            {
              content: formatMessageNew('languageObj.qrCode.errorcode_' + err.errorCode)
            },
            () => {
              epcInputRef.current.focus({ cursor: 'all' })
              errorNum = 0
            }
          )
        }
      })
  }
  const clearInfoFun = () => {
    setEpcValue('')
    setQrCodeValue('')
  }
  const backFirstPage = () => {
    history.push('/rf/login')
  }
  return (
    <ConfigProvider
      theme={{
        token: {
          fontSize: 14
        }
      }}
    >
      <div className="h100">
        <div className="displayFlex alignCenter">
          <div className="bind_label">{formatMessageNew('languageObj.qrCode.rfidEpc')}：</div>
          <div className="bind_label2">
            <Input
              className="pt5 pb5"
              value={epcValue}
              allowClear
              ref={epcInputRef}
              readOnly={inputReadOnly}
              disabled={qrCodeValue && !codeSkuValue}
              placeholder={`${formatMessageNew('languageObj.nsptagLocale.pleaseScan')}${formatMessageNew(
                'languageObj.qrCode.rfidEpc'
              )}`}
              onChange={onEpcChange}
              onFocus={onInputFocus}
            />
          </div>
        </div>
        <div className="displayFlex alignCenter mt5">
          <div className="bind_label"></div>
          <div className="bind_label2">
            <div style={{ minHeight: 24 }} className="color-primary">
              {epcValue && skuValue}
            </div>
          </div>
        </div>
        <div className="displayFlex alignCenter mt5">
          <div className="bind_label">{formatMessageNew('languageObj.qrCode.qrCode')}：</div>
          <div className="bind_label2">
            <Input
              className="pt5 pb5"
              value={qrCodeValue}
              ref={qrCodeInputRef}
              allowClear
              readOnly={inputReadOnly}
              disabled={epcValue && !skuValue}
              placeholder={`${formatMessageNew('languageObj.nsptagLocale.pleaseScan')}${formatMessageNew(
                'languageObj.qrCode.qrCode'
              )}`}
              onFocus={onInputFocus}
              onKeyDown={e => onInputKeyDown(e, 'qr')}
              onChange={onInputChange}
            />
          </div>
        </div>
        <div className="displayFlex alignCenter mt5">
          <div className="bind_label"></div>
          <div className="bind_label2">
            <div style={{ minHeight: 24 }} className="color-primary">
              {qrCodeValue && codeSkuValue}
            </div>
          </div>
        </div>
        <Row gutter={[10, 0]} className="mt16">
          <Col span={12}>
            <Button type="primary" onClick={unbindingFun} className="phone-btn2 reset-btn">
              {`${formatMessageNew('languageObj.commonLocale.confirmTitle')}`}
            </Button>
          </Col>
          <Col span={12}>
            <Button onClick={clearInfoFun} className="phone-btn2 reset-btn">
              {`${formatMessageNew('languageObj.commonLocale.clear')}`}
            </Button>
          </Col>
        </Row>
        <div className="position-fixed-btn">
          <Button type="primary" className="phone-btn2 reset-btn mt0" onClick={backFirstPage}>
            {`${formatMessageNew('languageObj.qrCode.backFirstPage')}`}
          </Button>
        </div>
      </div>
    </ConfigProvider>
  )
}
export default QrCodeUnbindByPiecePage
